import {VALUE_STYLES_CSS} from './crosshairUtils';

// Global, document-scoped CSS for the line-plot crosshair + tooltip.
//
// These rules previously lived in inline <style> elements rendered *inside* the
// crosshair subtree (LinePlotCrosshairContent, LinePlotCrosshair, LinePlot).
// That subtree re-renders on every mousemove (activeX changes per pixel), and
// React mounting/unmounting a <style> element mutates the document's stylesheet
// set — which forces the browser to re-evaluate every selector, i.e. a
// full-document style recalc on each move. Injecting these rules once, outside
// the render path, keeps them from churning the stylesheet set per move.
//
// All selectors are global (class/attribute), so a single document-level
// instance is behavior-identical to the per-instance inline <style> elements.
const STYLE_ELEMENT_ID = 'wb-line-plot-crosshair-styles';

const CROSSHAIR_GLOBAL_CSS = `
${VALUE_STYLES_CSS}
.hide-rv-crosshair-line .rv-crosshair__line {
  display: none;
}
/*
  We don't have direct access to the React-vis crosshair box so we style it here.
  These rules keep the overlay from overlapping the vertical bar showing the
  intersection of the x-axis and the lines.
*/
.rv-crosshair__inner--right {
  left: 12px;
}
.rv-crosshair__inner--left {
  right: 12px;
}
`;

/** Inject the crosshair's global stylesheet once. Idempotent and safe to call
 * from every render/mount; subsequent calls are a single getElementById check. */
export function ensureCrosshairGlobalStyles(): void {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.getElementById(STYLE_ELEMENT_ID) != null) {
    return;
  }
  const styleEl = document.createElement('style');
  styleEl.id = STYLE_ELEMENT_ID;
  styleEl.textContent = CROSSHAIR_GLOBAL_CSS;
  document.head.appendChild(styleEl);
}
